import React from 'react'

class Scaffolding extends React.Component {

  constructor() {
    super()
    this.count = {}
    this.inc = this.inc.bind(this)
  }

  inc(type) {
    let count = this.count
    count[type] = this.count[type] + 1
  }

  reset() {
    this.count = {
      contact: 0,
      content: 0,
      content_link: 0,
      quote: 0,
      text: 0,
      list: 0,
      boxes: 0,
      image: 0
    }
  }

  render() {
    const { children } = props
    {
      children
    }
  }

}

export default Scaffolding



// WEBPACK FOOTER //
// ./src/components/scaffolding/dynamic/index.js